import { type JSX } from 'react';

import { Button } from 'Components/Buttons/Buttons';

export interface CountLinkButtonProps {
    count: number;
    noun: string;
    onClick: () => void;
}

/** Renders a link-style button displaying "N Noun(s)" that triggers a callback when clicked. */
export const CountLinkButton = (props: CountLinkButtonProps): JSX.Element => {
    return (
        <Button variant="linkText" size="sm" onClick={props.onClick}>
            {`${props.count} ${props.count === 1 ? props.noun : `${props.noun}s`}`}
        </Button>
    );
};
